import { useMemo } from "react";

export function useDeviceType() {
    return useMemo(() => {
        const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

        const userAgent = navigator.userAgent.toLowerCase();

        const isMobile = isTouchDevice && /mobi|android|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

        const isTablet = isTouchDevice && /ipad|tablet|playbook|silk|android(?!.*mobi)/i.test(userAgent);

        const isDesktop = !isMobile && !isTablet;

        return { isMobile, isTablet, isDesktop };
    }, []);
}
